import script from "./NewWorkstationSubscriptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewWorkstationSubscriptionModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewWorkstationSubscriptionModal.vue?vue&type=style&index=0&id=177c12a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177c12a2"]])

export default __exports__